import Swiper from 'swiper/bundle';

export default class PartnerSlider {
    constructor() {
        // Check if .partner-slider exists in the DOM
        if (document.querySelector('.partner-slider')) {
            this.initSwiper();
        }
    }

    initSwiper() {
        const swiper = new Swiper('.partner-slider', {
            autoplay: {
                delay: 0,
                disableOnInteraction: true,
            },
            speed: 5000,
            autoHeight: false,
            slidesPerView: 2,
            loop: true,
            breakpoints: {
                480: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 40
                }
            }
        });
    }
}
